import React, { useState, useEffect, useContext } from 'react';
import 'react-tiny-fab/dist/styles.css';
import { useNavigate } from "react-router-dom";
import { getWebClient } from '../helpers/Helpers.js';
import Spinner from './components/Spinner';
import PromptError from './components/PromptError.js';
import Navbutton from './components/Navbutton.js';
import { MainSettingsContext } from '../App.js';

export default function DashboardEditOnly({ setAuthenticationToken }) {

    const { locationAndDates } = useContext(MainSettingsContext);

    const [viewMode, setViewMode] = useState('waiting');

    const [profile, setprofile] = useState(
        {
            company: "",
            city: "",
            country: "",
            typologyId: "",
            personInCharge: "",
            telephone: "",
            email: "",
            website: "",
            description: ""
        }
    );

    const navigate = useNavigate();

    const client = getWebClient();

    useEffect(() => {

        client.get(`/api/getprofile`)
            .then(function (response) {
                setprofile(response.data);
                setViewMode('');
                window.scrollTo(0, 0);
            })
            .catch(function (error) {
                console.log(error);
                setViewMode('error');
            });

    }, []);

    function handleProfileClick() {
        navigate("/profile");
    }

    function handleLogoutClick() {
        setAuthenticationToken(null);
        localStorage.removeItem("authenticationToken");
        sessionStorage.removeItem("searchParams");
        sessionStorage.removeItem("searchResults");
    }

    return (
        <>

            <section className="main-sec">
                <header className="header">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src="assets/images/logo.svg" alt="" />
                        </div>
                        <div className="col-md-6">
                            <h2>Workshop Agenda</h2>
                            <p>{locationAndDates}</p>
                        </div>
                    </div>
                </header>
                <div className="main-container">
                    <h1 className="main-heading">{profile.company}</h1>
                    <p className="main-pera">Welcome to the preparatory phase of your agenda.</p>
                    <ul className="btn-list">
                        <li> <button className="btn btn-secondary pro-btn" onClick={handleProfileClick}>Modify your profile</button> </li>
                    </ul>
                    <div className="main-card">
                        <h1>From this page you will be able to:</h1>
                        <div className="row">
                            <div className="col-md-12 mb-3 mt-3">
                                <h6>UPDATE YOUR PROFILE</h6>
                                <p>As a first step, we ask you to update your profile to make it attractive to your partners — describe what you do and what you offer if you are a SELLER, and what you are looking to purchase if you are a BUYER.</p>
                            </div>
                        </div>
                        <div className="col-md-12 text-center" style={{ marginTop: 20 }}>
                            <div className="back-btn">
                                <button className="btn btn-secondary" onClick={handleLogoutClick}>Log out</button>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer">
                    <ul>
                        <li>&copy; {new Date().getFullYear()} - PromAx Communication SA - <a target="_blank" rel="noreferrer" href='http://www.sihe.ch'>www.sihe.ch</a><br></br>Tel. 0041/91/6118070 - <a href="mailto:segreteria@sihe.ch">segreteria@sihe.ch </a></li>
                    </ul>
                </footer>
            </section>

            <Navbutton></Navbutton>

            <Spinner show={viewMode === 'waiting'}></Spinner>
            <PromptError show={viewMode === 'error'} setViewMode={setViewMode}></PromptError>
            
        </>
    );

}